import React from 'react';
import { CreditCardIcon, FileTextIcon, GlobeIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
type TrustStripProps = {
  className?: string;
  /** 'short' is the 3-item strip under a CTA, 'full' adds the payment and format items. */
  variant?: 'short' | 'full';
};
const SHORT = [{
  Icon: ShieldCheckIcon,
  label: '7-Day guarantee'
}, {
  Icon: LockIcon,
  label: 'Secure payment'
}, {
  Icon: CreditCardIcon,
  label: 'Local currency'
}];
const FULL = [{
  Icon: ZapIcon,
  label: 'Access in 5 min'
}, {
  Icon: ShieldCheckIcon,
  label: '7-Day guarantee'
}, {
  Icon: CreditCardIcon,
  label: 'Stripe · PayPal · Local'
}, {
  Icon: GlobeIcon,
  label: 'Pay in your currency'
}, {
  Icon: FileTextIcon,
  label: '100% PDF'
}];
export function TrustStrip({
  className = '',
  variant = 'short'
}: TrustStripProps) {
  const items = variant === 'full' ? FULL : SHORT;
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] ${className}`} data-id="element-216" data-mp="3qq4jicmzlp0h">
      {items.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5" data-id="element-217" data-mp="3rsh28qs3486t">
          <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-218" data-mp="3ds6c5pylmxmp" />
          {label}
        </li>)}
    </ul>;
}